import { useMutation, useQuery } from "@tanstack/react-query";
import { APIErrorResponse } from "src/types/generic";
import apiClient from "../apiClient";

interface IParams {
  page?: number;
  enabled?: boolean;
}

export const useGetVendorsList = (params?: IParams) => {
  const { enabled = true, ...rest } = params ?? {};
  return useQuery<any, APIErrorResponse, any>({
    queryKey: ["get-operation-cost-vendors-list", rest.page],
    queryFn: async () => {
      return apiClient.get(`/api/vendors`, { params: rest });
    },
    enabled,
  });
};

interface IVendorBody {
  id?: string;
  name?: string;
  start_balance?: number | string;
}

export const useAddVendorMutation = () =>
  useMutation<void, APIErrorResponse, IVendorBody>({
    mutationFn: async (data) => {
      return apiClient.post(`/api/vendors`, data);
    },
  });

export const useUpdateVendorMutation = () =>
  useMutation<void, APIErrorResponse, IVendorBody>({
    mutationFn: async (data) => {
      const { id, ...rest } = data;
      return apiClient.put(`/api/vendors/${id}`, rest);
    },
  });

export const useDeleteVendorMutation = () =>
  useMutation<void, APIErrorResponse, number>({
    mutationFn: async (id) => {
      return apiClient.delete(`/api/vendors/${id}`);
    },
  });

export const useGetSVendorBalance = (vendor_id: number) => {
  return useQuery<any, APIErrorResponse, any>({
    queryKey: ["get-vendor-balance", vendor_id],
    queryFn: async () => {
      return apiClient.get(`/api/vendors/balance?vendor_id=${vendor_id}`);
    },
  });
};
